import { checkDownloadLimit } from "@/services";
import { openUdesk } from "@/utils/initUdesk";
import useReq from "@/utils/useReq";
import { Button } from "antd";
import HBModal, { type ModalProps } from "../HBModal";
import ModalWrap from "../HBModal/ModalWrap";
import styles from "./index.module.less";
/**
 * 会员下载素材受限的提醒弹窗
 */
function RawDownloadLimitModal({
  materialId,
  onCancel,
  ...props
}: {
  materialId: number;
  onCancel?: () => void;
} & ModalProps) {
  const { data: limitDesc } = useReq(async () => {
    // 对应文档：https://doc.huanleguang.com/pages/viewpage.action?pageId=396528052
    const limit = await checkDownloadLimit(materialId);

    if (limit.sensitive_limit) {
      return "当前素材不可用于敏感用途，不支持下载/编辑。如需更多信息或支持，请联系您的客户经理。";
    }

    if (
      limit.vcg_limited || // 视觉中国限制
      (limit.category_limited && !limit.personal_category_vip) || // 品类限制
      limit.material_vip_produced // 自产素材限制
    ) {
      return "由于您的套餐限制，您无法下载/编辑该素材。如需更多信息或支持，请联系您的客户经理。";
    }

    if (limit.category_limited) {
      return "您的会员套餐仅可使用平面模板和视频模板。如需更多信息或支持，请联系在线客服";
    }
  });

  return (
    <HBModal
      width={480}
      className={styles.downloadLimitModal}
      footer={null}
      onCancel={onCancel}
      {...props}
    >
      <div className={styles.title}>素材下载/编辑受限</div>
      <div className={styles.desc}>
        <div>{limitDesc}</div>
      </div>
      <div className={styles.footer}>
        <Button onClick={openUdesk}>联系在线客服</Button>
        <Button type="primary" onClick={onCancel}>
          我知道了
        </Button>
      </div>
    </HBModal>
  );
}

/**单品类会员下载品类外素材是的提醒弹窗 */
const DownloadLimitModal = ModalWrap(RawDownloadLimitModal);

export default DownloadLimitModal;
